<template>
  <sweet-modal blocking title="Branch Office Table" ref="modal" class="modal" v-on:close="closeModal">
    <el-form
        :model="form"
        size="mini"
        label-width="115px"
        ref="form"
        status-icon>
      <el-table
          max-height="650"
          :data="form.list"
          size="mini"
          border
          style="width: 100%"
          :empty-text="$t('general_noData')">
        <el-table-column
            prop="tinCode"
            width="110"
            label="TIN Code">
          <template slot-scope="scope">
            <el-form-item
              label-width="0"
              :prop="'list.' + scope.$index + '.tinCode'"
              :rules="{
                required: true, message: 'Field is required', trigger: 'blur'
              }">
              <el-input v-model="scope.row.tinCode" :readonly="readonly" size="mini"></el-input>
            </el-form-item>
          </template>
        </el-table-column>
        <el-table-column
            prop="buId"
            width="110"
            label="TF BU">
          <template slot-scope="scope">
            <el-form-item
              label-width="0"
              :prop="'list.' + scope.$index + '.buId'"
              :rules="{
                required: true, message: 'Field is required', trigger: 'blur'
              }">
              <el-select :disabled="readonly" v-model="scope.row.buId" size="mini">
                <el-option
                    v-for="item in buList"
                    :key="item.id"
                    :label="item.name"
                    :value="item.id">
                </el-option>
              </el-select>
            </el-form-item>
          </template>
        </el-table-column>
        <el-table-column
            prop="countryId"
            width="100"
            label="Country">
          <template slot-scope="scope">
            <el-form-item
                label-width="0"
                :prop="'list.' + scope.$index + '.countryId'">
              <el-select
                  no-data-text="no data"
                  :disabled="readonly"
                  v-model="scope.row.countryId"
                  @visible-change="loadCountryList($event, scope.row)"
                  size="mini"
                  @change="changeCountry(scope.row)"
                  filterable>
                <el-option
                    v-for="item in scope.row.countryList"
                    :key="item.id"
                    :label="item.name"
                    :value="item.id">
                </el-option>
              </el-select>
            </el-form-item>
          </template>
        </el-table-column>
        <el-table-column
            prop="postCode"
            width="100"
            label="Post Code">
          <template slot-scope="scope">
            <el-form-item
                label-width="0"
                :prop="'list.' + scope.$index + '.postCode'">
              <el-input :disabled="!scope.row.countryId" :readonly="readonly" v-model="scope.row.postCode" size="mini"></el-input>
            </el-form-item>
          </template>
        </el-table-column>
        <el-table-column
            prop="stateId"
            width="180"
            label="State / Province / Country">
          <template slot-scope="scope">
            <el-form-item
                label-width="0"
                :prop="'list.' + scope.$index + '.stateId'">
              <el-select
                  no-data-text="no data"
                  :disabled="!scope.row.countryId || readonly"
                  v-model="scope.row.stateId"
                  size="mini"
                  filterable
                  @change="changeState(scope.row)">
                <el-option
                    v-for="item in scope.row.stateList"
                    :key="item.id"
                    :label="item.name"
                    :value="item.id">
                </el-option>
              </el-select>
            </el-form-item>
          </template>
        </el-table-column>
        <el-table-column
            prop="cityId"
            width="100"
            label="City">
          <template slot-scope="scope">
            <el-form-item
                label-width="0"
                :prop="'list.' + scope.$index + '.cityId'">
              <el-select
                  no-data-text="no data"
                  :disabled="!scope.row.countryId || !scope.row.stateId || readonly"
                  v-model="scope.row.cityId"
                  size="mini"
                  filterable>
                <el-option
                    v-for="item in scope.row.cityList"
                    :key="item.id"
                    :label="item.name"
                    :value="item.id">
                </el-option>
              </el-select>
            </el-form-item>
          </template>
        </el-table-column>
        <el-table-column
            prop="addressLine1"
            width="110"
            label="Address Line 1">
          <template slot-scope="scope">
            <el-form-item
              label-width="0"
              :prop="'list.' + scope.$index + '.addressLine1'">
              <el-input :readonly="readonly" v-model="scope.row.addressLine1" size="mini"></el-input>
            </el-form-item>
          </template>
        </el-table-column>
        <el-table-column
          prop="addressLine2"
          width="110"
          label="Address Line 2">
          <template slot-scope="scope">
            <el-form-item
                label-width="0"
                :prop="'list.' + scope.$index + '.addressLine2'">
              <el-input :readonly="readonly" v-model="scope.row.addressLine2" size="mini"></el-input>
            </el-form-item>
          </template>
        </el-table-column>
        <el-table-column
            prop="addressLine3"
            width="110"
            label="Address Line 3">
          <template slot-scope="scope">
            <el-form-item
                label-width="0"
                :prop="'list.' + scope.$index + '.addressLine3'">
              <el-input :readonly="readonly" v-model="scope.row.addressLine3" size="mini"></el-input>
            </el-form-item>
          </template>
        </el-table-column>
        <el-table-column
            prop="regionalDistrictOfficeId"
            width="180"
            label="Regional District Office">
          <template slot-scope="scope">
            <el-form-item
                label-width="0"
                :prop="'list.' + scope.$index + '.regionalDistrictOfficeId'"
                :rules="{
                required: true, message: 'Field is required', trigger: 'blur'
              }">
              <el-select :disabled="readonly" v-model="scope.row.regionalDistrictOfficeId" size="mini">
                <el-option
                    v-for="item in rdos"
                    :key="item.id"
                    :label="item.name"
                    :value="item.id">
                </el-option>
              </el-select>
            </el-form-item>
          </template>
        </el-table-column>
        <el-table-column
            v-if="!readonly"
            width="65">
          <template slot-scope="scope">
            <el-button
                @click="() => form.list.splice(scope.$index, 1)"
                size="mini"
                plain>
              <i class="fas fa-trash"></i>
            </el-button>
          </template>
        </el-table-column>
      </el-table>
    </el-form>
    <div v-if="!readonly" style="display: flex; width: 100%; justify-content: flex-end; margin-top: 20px;">
      <el-button
          size="mini"
          type="primary"
          plain
          style="margin-right: 10px"
          @click="addLine">Add Line</el-button>
      <el-button
          size="mini"
          type="primary"
          plain
          @click="save">Save</el-button>
    </div>
  </sweet-modal>
</template>

<script>
import { SweetModal } from '@totalflow4/tfsweet-modal-vue'
import axios from 'axios'
export default {
  name: "BranchOfficeModal",
  components: {
    SweetModal
  },
  props: {
    readonly: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    companyLayout() {
      return this.$store.getters.getCompanyLayout
    },
  },
  data() {
    return {
      form: {
        list: []
      },
      buList: [],
      rdos: [],
    }
  },
  methods: {
    async openModal() {
      const loader = this.$loading.show()
      axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token');
      axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();
      const { data } = await axios.get(`/api/v1/open-branch-office/item?companyId=${this.$route.query.companyId}`)
      this.form.list = data.item.map(val => ({
        tinCode: val.tinCode,
        buId: val.buId,
        countryId: val.country ? val.country.id : null,
        postCode: val.postCode,
        stateId: val.state ? val.state.id : null,
        cityId: val.city ? val.city.id : null,
        addressLine1: val.addressLine1,
        addressLine2: val.addressLine2,
        addressLine3: val.addressLine3,
        regionalDistrictOfficeId: val.regionalDistrictOfficeId,
        //
        countryList: val.country ? [val.country] : [],
        stateList: val.state ? [val.state] : [],
        cityList: val.city ? [val.city] : []
      }))
      const rdos = await axios.get(`/api/v1/rdo/list?countryId=0`)
      this.rdos = rdos.data.list
      const bus = await axios.post(`/api/v1/businessUnits/list?companyId=${this.$route.query.companyId}`)
      this.buList = bus.data.list
      loader.hide()
      this.$refs.modal.open()
    },
    async loadList(type, id) {
      let loader = this.$loading.show();
      axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token');
      axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();
      const response = await axios.get(`/api/v1/country/directories?type=${type}&id=${id}`)
      loader.hide()
      return response.data.list
    },
    closeModal() {
      this.form.list = []
      this.buList = []
      this.rdos = []
      this.$refs['form'].resetFields();
    },
    addLine() {
      this.$refs['form'].validate((valid) => {
        if (valid) {
          this.form.list.push({
            tinCode: null,
            buId: null,
            countryId: null,
            postCode: null,
            stateId: null,
            cityId: null,
            addressLine1: null,
            addressLine2: null,
            addressLine3: null,
            regionalDistrictOfficeId: null,
            //
            countryList: [],
            stateList: [],
            cityList: []
          })
        }
      })
    },
    async loadCountryList(val, row) {
      if (val) {
        row.countryList = await this.loadList('country', null, 'countryList')
      }
    },
    async changeCountry(row) {
      row.stateId = null
      row.cityId = null
      row.stateList = []
      row.cityList = []
      row.stateList = await this.loadList('state', row.countryId, 'stateList')
    },
    async changeState(row) {
      row.cityId = null
      row.cityList = []
      row.cityList = await this.loadList('city', row.stateId, 'cityList')
    },
    save() {
      this.$refs['form'].validate(async (valid) => {
        if (valid) {
          const loader = this.$loading.show()
          axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token');
          axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();
          const payload = {
            itemList: this.form.list.map(val => ({
              cityId: val.cityId,
              stateId: val.stateId,
              countryId: val.countryId,
              regionalDistrictOfficeId: val.regionalDistrictOfficeId,
              buId: val.buId,
              tinCode: val.tinCode,
              addressLine1: val.addressLine1,
              addressLine2: val.addressLine2,
              addressLine3: val.addressLine3,
              postCode: val.postCode
            }))
          }
          await axios.post(`/api/v1/open-branch-office/save?companyId=${this.$route.query.companyId}`, payload)
          this.$refs.modal.close()
          loader.hide()
        }
      })
    }
  }
}
</script>

<style scoped>

</style>
